import React from 'react';
import { Navbar } from '../components/sections/Navbar';
import { Hero } from '../components/sections/Hero';
import { Benefits } from '../components/sections/Benefits';
import { Process } from '../components/sections/Process';
import { Areas } from '../components/sections/Areas';
import { Doctor } from '../components/sections/Doctor';
import { Authority } from '../components/sections/Authority';
import { Testimonials } from '../components/sections/Testimonials';
import { FAQ } from '../components/sections/FAQ';
import { Location } from '../components/sections/Location';
import { Contact } from '../components/sections/Contact';
import { Footer } from '../components/sections/Footer';
import { StickyMobileCta } from '../components/ui/StickyMobileCta';
import { CherryFinancing } from '../components/sections/CherryFinancing';
export function Home() {
  return <main className="min-h-screen bg-brand-cream" data-id="element-513" data-mp="3kxd1139qfyyo">
      <Navbar data-id="element-514" data-mp="3ow42fml8e2rl" />
      <Hero data-id="element-515" data-mp="3ovki5z83z2ae" />
      <Benefits data-id="element-516" data-mp="3ovauwjeg798e" />
      <Process data-id="element-517" data-mp="3oyyk56cv19hb" />
      <Areas data-id="element-518" data-mp="30wrnkc0kxpdf" />
      <Doctor data-id="element-519" data-mp="30xb9s4x9izx9" />
      <Authority data-id="element-520" data-mp="30x1eq2xd22kp" />
      <Testimonials data-id="element-521" data-mp="30vgjsc74whmb" />
      <FAQ data-id="element-522" data-mp="30up1g32jsgdz" />
      <Location data-id="element-523" data-mp="30uf9wb1uu166" />
      <Contact data-id="element-524" data-mp="2vxyc0p4us8fw" />
      <Footer data-id="element-525" data-mp="2vxf31xx6kue0" />
      <StickyMobileCta data-id="element-526" data-mp="2vyzz5rz58ldz" />
      <CherryFinancing data-id="element-527" data-mp="2vyhrlz716kqr" />
    </main>;
}